import { HiddenLayout } from './hidden.layout';
import { PlatformLayout } from './platform.layout';
import { PublicLayout } from './public.layout';

export const Layout = {
  Platform: PlatformLayout,
  Public: PublicLayout,
  Hidden: HiddenLayout,
};
